'use strict';

var FaresSurchargeUploadDirective = function FaresSurchargeUploadDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-surcharge-upload.html'),
    controller: 'FaresSurchargeUploadController',
    link: function link(scope) {
      scope.$on('fares-surcharge-upload-grid:saveChanges', scope.saveChanges);
      scope.$on('fares-surcharge-upload-grid:remove', scope.removeRows);
      scope.$on('fares-surcharge-upload-grid:export', scope.exportToCSV);
    }
  };
};
FaresSurchargeUploadDirective.$inject = [];
module.exports = FaresSurchargeUploadDirective;